<div class="d-block text-end">
        <button class="btn btn-primary-dark btn-sm rounded-small ms-3 text-xxs shadow text-dark mt-3 " data-bs-toggle="modal"
          data-bs-target="#create_form">
          Create Form
        </button>
      </div>

<div class="p-2">
  <div class="rounded-lg p-3 table-responsive text-xs">

    <table v-if="table_safe_form_list.length > 0" id="form_management_table" class="table table-hover">
      <thead class="custom-header">
        <tr>
          <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">No</th>
          <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Form</th>
          <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Description</th>
          <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Status</th>
          <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Date Created</th>
          <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(form, index) in table_safe_form_list" :key="form.id">
          <td class="text-xxs text-start">{{ index + 1 }}</td>
          <td class="text-xxs text-start">{{ form['Form'] }}</td>
          <td class="text-xxs text-start">{{ form['Description'] }}</td>
          <td class="text-xxs text-start">{{ form['Status'] }}</td>
          <td class="text-xxs text-start">{{ form['Date Created'] }}</td>
          <td>
            <div class="d-flex flex-nowrap">
                <!-- <DropdownActionsWrapper :row="form" :maxButtons="2" :useIconList="true"> -->
                   <!-- <template #default="{ row }"> -->
                    <button @click="redirect_to_create_entity(form)"
                      class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow me-2 text-dark">View</button>
                    <button @click="open_edit_modal(form)"
                      class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow me-2 text-dark"
                      data-bs-toggle="modal"
                      data-bs-target="#edit_form">Edit</button>
                    <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow me-2 text-dark"
                      @click="redirect_to_manage_assigned_workflows(form.id)">Manage Workflow</button>
                    <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow me-2 text-dark"
                      @click="selected_share_form_id(form.id)" data-bs-toggle="modal" data-bs-target="#share_trust_form">Share</button>
                    <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow me-2 text-dark"
                      data-bs-toggle="modal" data-bs-target="#assign_entity_type_modal"
                      @click="opening_assign_modal(form)">
                      Assign Case Type Form
                    </button>
                   <!-- </template> -->
                <!-- </DropdownActionsWrapper> -->
             
              
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-else class="text-center py-5">
      <h6 class="text-muted text-xs mb-2">No Case Forms Found</h6>
      <p class="text-xxs text-muted">Click the button above to create your first Case form.</p>
    </div>

  </div>
</div>

<!-- Create Trust Form Modal -->
 <teleport to="body">
<div class="modal fade" id="create_form" tabindex="-1" aria-labelledby="create_form_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="create_form_label">Create Form</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="modal-form-group form-group mb-3">
          <label for="form_name" class="modal-form-label form-label text-xxs">Form Name:</label>
          <input type="text" id="form_name" v-model="form_name"
            class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
            placeholder="Please enter a name for the form" aria-labelledby="form_name">
          <small id="form_name_error" class="text-danger p-2 text-xxs fw-bold d-none project-name-messages">Please enter
            a name for the form</small>
          <small id="form_name_generic_error" class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>

        <div class="modal-form-group form-group mb-3">
          <label for="name_description" class="modal-form-label form-label text-xxs">Form Description
            (Optional):</label>
          <input type="text" id="name_description" v-model="form_description"
            class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
            placeholder="Please enter a description for the form" aria-labelledby="name_description">
          <small id="name_description_error"
            class="text-danger p-2 text-xxs fw-bold d-none project-description-messages">Please enter a description for
            the form</small>
          <small id="name_description_generic_error"
            class="text-danger p-2 text-xxs fw-bold d-none error-messages"></small>
        </div>
        <div class="modal-form-group form-group mb-3">
          <label class="modal-form-label form-label text-xxs">Form Type:</label>
        <div class="position-relative">
          <select class="modal-form-control form-control text-xxs pe-5"
                  v-model="form_type_id">
              <option disabled value="" selected hidden>Select Form Type</option>
              <option v-for="type in form_types" :key="type.id" :value="type.id">
                  {{ type.form_type }}
              </option>
          </select>
          <i class="bi bi-chevron-down position-absolute top-50 end-0 translate-middle-y me-3 text-secondary cursor-pointer dropdown-arrow"></i>
        </div>
        </div>
      </div>
      <div class="modal-footer border-0 p-2 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
          @click="create_form">Save</button>
      </div>
    </div>
  </div>
</div>
</teleport>

<teleport to="body">
<div class="modal fade" id="edit_form" tabindex="-1" aria-labelledby="edit_form_label" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <h5 class="modal-title text-white text-xxs">Edit Form</h5>
        <button type="button" class="modal-btn-close btn-close"data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
              <label class="modal-form-label form-label text-xxs">Form Name:</label>
              <input type="text" class="modal-form-control form-control text-xxs" v-model="form_name" placeholder="Enter form name">
          </div>
          <div class="mb-3">
              <label class="modal-form-label form-label text-xxs">Form Description:</label>
              <textarea class="modal-form-control form-control text-xxs" v-model="form_description" ></textarea>
          </div>
        </div>
        <div class="modal-footer">
        <button
          type="button"
          class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="update_form">
          Save
        </button>
        </div>
    </div>
    </div>
</div>
</teleport>

<!-- Share Trust Form Modal -->
<teleport to="body">
<div class="modal fade" id="share_trust_form" tabindex="-1" aria-labelledby="shareTrustFormLabel" aria-hidden="true"
  ref="shareTrustFormModal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <!-- Modal Header -->
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <div class="modal-title text-white">
          <p class=" text-gray-300 m-0">{{ main_form.form_name }}</p>
        </div>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <!-- Info Alert -->
        <div class="alert alert-info mt-3 d-flex align-items-center text-xxs">
          <i class="fa-solid fa-info-circle me-2"></i>
          <span>The assigned user will receive an email with instructions to access and complete their case
            setup.</span>
        </div>
        <!-- Assign Forms -->
        <div class="form-section mt-4 text-xxs">
          <label class="fw-bold mb-1" for="email">Assign forms by Email</label>
          <input type="email" v-model="email"
            class="modal-form-control form-control form-control-sm text-xxs p-2 rounded"
            placeholder="Enter email address" />

          <div class="d-flex justify-content-end"> 
            <button class="btn btn-primary-dark share-button mt-3 d-flex align-items-center text-xxs"
              @click="share_trust_setup">
              <i class="fa-solid fa-paper-plane me-2"></i> Share Case Setup
            </button>
          </div>
          
        </div>

        <!-- Sub-Entity Forms -->
        <div class="mt-4" v-if="sub_entity_forms.length > 0">
          <label class="fw-bold text-xxs">Sub-Case Forms (will also be shared)</label>
          <div v-for="(sub, index) in sub_entity_forms" :key="sub.id"
            class="p-3 border rounded bg-light text-primary border-color mb-2">
            <p class="mb-1 fw-bold text-primary-blue">
              <i class="fa-solid fa-circle-check me-1"></i> {{ sub.form_name }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</teleport>

<!-- Assign Entity Type Form Modal -->
<teleport to="body">
<div class="modal fade" id="assign_entity_type_modal" tabindex="-1" aria-labelledby="assign_entity_type_modal_label" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content shadow-lg border-0 rounded-3">

      <!-- Modal Header -->
      <div class="modal-header cute-header d-flex align-items-center justify-content-between px-4 py-3 border-0 rounded-top-3">
        <h5 class="modal-title text-white text-xxs fw-bold mb-0" id="assign_entity_form_modal_label">Assign Case Type Form</h5>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body p-4 bg-light">
        <!-- Section Title -->
        <div class="d-flex align-items-center justify-content-between mb-3">
          <div>
            <label class="form-label text-xxs fw-semibold me-2 mb-0">
              Assign Case Type Form to:
            </label>
            <span class="fw-bold text-dark text-xxs">
            </span>
          </div>
          <span class="badge bg-secondary rounded-pill text-xxs">
            Available
          </span>
        </div>


        <!-- DataTable -->
        <div  class="table-responsive">
          <table class="table table-bordered table-hover align-middle" id="assign_sub_entity_table" :key="'assign-table-' + datatable_key">
            <thead class="custom-header">
              <tr class="text-x">
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">No</th>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Template Name</th>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Status</th>
                <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Assign</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(child_item, index) in available_children" :key="child_item.id" class="text-xxs">
                <td class="text-xxs text-start">{{ index + 1 }}</td>
                <td class="text-xxs text-start">{{ child_item.template_name }}</td>
                <td>
                  <span class="badge"
                        :class="{ 'bg-success': child_item.is_assigned, 'bg-secondary': !child_item.is_assigned }">
                    {{ child_item.is_assigned ? 'Assigned' : 'Unassigned' }}
                  </span>
                </td>
                <td class="text-center">
                  <div class="form-check form-switch d-flex justify-content-center">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                      :id="'toggle-' + child_item.id"
                      :checked="child_item.is_assigned"
                      :disabled="child_item.is_loading"
                      @change="on_toggle_assign(child_item, $event)"
                    >
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</div>
</teleport>